/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export const fsMultiplierDefault = 24 // this is for SaaS plans
export const ramToStorageMultiplier = 32 // this is for ECE-DNT plans

export const MEMORY_TO_STORAGE_MULTIPLIER_MIN_GB = 1
export const MEMORY_TO_STORAGE_MULTIPLIER_MAX_GB = 200
